<template>
    <div>
        <el-card class="box-card" >
            <div class="text item">
                <span class="edit-content"> 创建用户</span>
                <el-button type="primary" style="float: right" @click=adduser>创建</el-button>
            </div>
        </el-card>
        <Input :labels="message" @confirm="Todo_Message" @cancel="Cancel_Message" v-if="isMessage"></Input>
    </div>
</template>

<script>
    import Input from "../input"
    export default {
        name: "userAdd",
        components:{
            Input
        },
        data() {
            return{
                message:[{
                    key:"name",
                    name:"名称",
                    type:"normal",
                    must_write:1
                },{
                    key:"desc",
                    name:"描述",
                    type:"normal",
                    must_write:1
                },{
                    key:"phone",
                    name:"手机号",
                    type:"normal",
                    must_write:1
                },{
                    key:"head_id",
                    name:"总部",
                    type:"option",
                    must_write:1
                }
                ],
                isMessage:false
            }
        },
        methods:{
            async Todo_Message(val){

                const { data: res } = await this.$http.post('',
                    {
                        "oper": "add",
                        "ent": "user",
                        "info": val
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.$message("操作成功");
                    this.isMessage=false;
                }
                else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
            },
            Cancel_Message(){
                this.isMessage=false;
            },
            adduser(){
                this.isMessage=true;
            }
        }
    }
</script>

<style scoped>
    .box-card {
        width: 100%;
    }
    .text {
        font-size: 18px;
    }

    .item {
        margin-bottom: 18px;
    }
    .edit-content{
        font-size: 18px;
        line-height: 2em;
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }
</style>
